// Mock data for Khoushik Tours & Travels

import hatchbackImg from "../images/hatchback.png";
import sedanImg from "../images/sedan.png";
import suvImg from "../images/ertiga.png";
import innovaImg from "../images/innova.png";
import innovaCrysteaImg from "../images/innova_crysta.png";
import tempoImg from "../images/TempoTraveller.png";
import miniBusImg from "../images/minibus.png";
import busImg from "../images/bus.png";



export const vehicleFleet = [
  {
    id: 1,
    name: "Hatchback Cars",
    description: "Compact and fuel-efficient cars best suited for city rides, short trips, and hassle-free daily travel.",
    pricePerKm: "10",
    capacity: "4 passengers",
    image: hatchbackImg
  },
  {
    id: 2,
    name: "Sedan Cars",
    description: "Ideal for city travel, airport transfers, and business trips.",
    pricePerKm: "12",
    capacity: "4 passengers",
    image: sedanImg
  },
  {
    id: 3,
    name: "SUVs",
    description: "Spacious and comfortable vehicles designed for family trips, highway drives, and carrying extra luggage with ease.",
    pricePerKm: "14",
    capacity: "6-7 passengers",
    image: suvImg
  },
  {
    id: 4,
    name: "Innova",
    description: "A reliable and comfortable choice for outstation travel, known for smooth rides and excellent passenger comfort.",
    pricePerKm: "16",
    capacity: "6-7 passengers",
    image: innovaImg
  },
  {
    id: 5,
    name: "Innova Crysta",
    description: "A premium MPV offering superior comfort, powerful performance, and a refined travel experience for long journeys.",
    pricePerKm: "18",
    capacity: "6-7 passengers",
    image: innovaCrysteaImg
  },
  {
    id: 6,
    name: "Tempo Travellers",
    description: "Best suited for group tours, temple visits, and weekend trips.",
    pricePerKm: "20",
    capacity: "10 - 12 passengers",
    image: tempoImg
  },
  {
    id: 7,
    name: "Mini-Bus",
    description: "Suitable for corporate travel and school trips.",
    pricePerKm: "30 - 40",
    capacity: "18 - 25 passengers",
    image: miniBusImg
  },
  {
    id: 8,
    name: "Buses",
    description: "Suitable for weddings, and large groups.",
    pricePerKm: "40 - 50",
    capacity: "25 - 50 passengers",
    image: busImg
  }
];

export const services = [
  { id: 1, title: "Local City Pick-Up & Drop", icon: "MapPin" },
  { id: 2, title: "Airport Pickup & Drop", icon: "Plane" },
  { id: 3, title: "Outstation Trips", icon: "Route" },
  { id: 4, title: "One-Day & Multi-Day Tours", icon: "Calendar" },
  { id: 5, title: "Family & Group Travel", icon: "Users" },
  { id: 6, title: "Corporate & Event Transportation", icon: "Building" }
];

export const travelCategories = [
  { id: 1, title: "City & Daily Travel", icon: "Car" },
  { id: 2, title: "Airport Transfers", icon: "PlaneTakeoff" },
  { id: 3, title: "Outstation & Long-Distance", icon: "Navigation" },
  { id: 4, title: "Temple & Pilgrimage Tours", icon: "Church" },
  { id: 5, title: "Weekend Getaways", icon: "Mountain" },
  { id: 6, title: "Family & Group Tours", icon: "Heart" },
  { id: 7, title: "Corporate & Office Travel", icon: "Briefcase" },
  { id: 8, title: "Weddings & Special Events", icon: "PartyPopper" }
];

export const bookingSteps = [
  { id: 1, step: "01", title: "Share Details", description: "Share your travel details with us" },
  { id: 2, step: "02", title: "Choose Vehicle", description: "Select the right vehicle for your trip" },
  { id: 3, step: "03", title: "Confirm Booking", description: "Confirm and finalize your booking" },
  { id: 4, step: "04", title: "Enjoy Journey", description: "Enjoy a smooth and comfortable journey" }
];

export const whyChooseUs = [
  { id: 1, title: "Experienced Drivers", description: "Professional and courteous drivers", icon: "UserCheck" },
  { id: 2, title: "Clean Vehicles", description: "Well-maintained and sanitized", icon: "Sparkles" },
  { id: 3, title: "On-Time Service", description: "Punctual pickup guaranteed", icon: "Clock" },
  { id: 4, title: "Transparent Pricing", description: "No hidden charges ever", icon: "IndianRupee" },
  { id: 5, title: "24/7 Support", description: "Round the clock assistance", icon: "Headphones" }
];

export const popularDestinations = [
  { id: 1, name: "Tirupati", type: "Temple Visits", image: "https://images.unsplash.com/photo-1544588440-fc7551331160?w=400&auto=format" },
  { id: 2, name: "Ooty & Coonoor", type: "Hill Stations", image: "https://images.unsplash.com/photo-1614761064673-d8cb9645e715?w=400&auto=format" },
  { id: 3, name: "Coorg", type: "Nature & Coffee Estates", image: "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&auto=format" },
  { id: 4, name: "Mysore", type: "Heritage & Palaces", image: "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=400&auto=format" },
  { id: 5, name: "Chikmagalur", type: "Weekend Getaways", image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&auto=format" },
  { id: 6, name: "Kodaikanal", type: "Family & Honeymoon", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=400&auto=format" },
  { id: 7, name: "Hampi", type: "Historical Tours", image: "https://images.unsplash.com/photo-1600100397608-e0e82c2f9c16?w=400&auto=format" },
  { id: 8, name: "Goa", type: "Beach Holidays", image: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=400&auto=format" }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "Bangalore",
    rating: 5,
    review: "Clean vehicles and polite drivers. Very smooth experience. Booked for a family trip to Coorg."
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Chennai",
    rating: 5,
    review: "On-time pickup and professional service. Highly recommended for airport transfers."
  },
  {
    id: 3,
    name: "Mohammed Farhan",
    location: "Hyderabad",
    rating: 5,
    review: "Used their tempo traveller for a group pilgrimage. Excellent service and reasonable pricing."
  }
];

export const vehicleTypes = [
  { value: "hatchback", label: "Hatchback Cars", price: "₹10/km" },
  { value: "sedan", label: "Sedan Cars", price: "₹12/km" },
  { value: "suv", label: "SUVs", price: "₹14/km" },
  { value: "innova", label: "Innova", price: "₹16/km" },
  { value: "innova-crysta", label: "Innova Crysta", price: "₹18/km" },
  { value: "tempo", label: "Tempo Travellers", price: "₹20/km" },
  { value: "mini-bus", label: "Mini Bus", price: "₹30/km - ₹40/km" },
  { value: "bus", label: "Buses", price: "₹40/km - ₹50/km" }
];


export const contactInfo = {
  phone1: "+91 97434 44111",
  phone2: "+91 98444 33380",
  whatsapp: "+91 97434 44111",
  email: "khoushik24.7@gmail.com",
  address: "South India"
};